import React from 'react';
import styles from './Footer.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
      <img src="https://cdn.builder.io/api/v1/image/assets/TEMP/49197869899ef63b19bd0b09137f149a625d88499688d6c6147ef469df8cbee3?placeholderIfAbsent=true&apiKey=de5d888f40ee495899f6e430a705765b" alt="" className={styles.footerImage} />
    </footer>
  );
}

export default Footer;